<template>
  <v-container fluid>
    <v-layout justify-center>
      <v-flex md12>
        <v-card title>
          <v-card-title>
            <h2>Colaboradores</h2>
          </v-card-title>
          <v-card-text>
            <DataTableMain
              :datatable="table"
              :on-success="successAction"
              :itemsAction="tableAction"
            />
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <EmployeeDialog v-if="get_dialogMain.dialog" />
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
import EmployeeDialog from '@/components/dialogs/EmployeeDialog'
export default {
  data: () => ({
    table: {
      header: {
        options: [
          {
            title: 'Refrescar',
            icon: 'mdi-cached',
            color: 'primary',
            action: 'refreshData'
          },
          {
            title: 'Nuevo',
            icon: 'mdi-plus',
            color: 'success',
            action: 'newData'
          }
        ],
        titles: [
          { text: 'Id', value: 'id', class: 'black--text' },
          { text: 'Nombrse', value: 'nombres', class: 'black--text' },
          { text: 'Apelidos', value: 'apellidos', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: 'Fecha Creacion', value: 'Created', class: 'black--text' },
          { text: 'Fecha Actualizada', value: 'Updated' },
          { text: '', value: 'Actions', class: 'black--text' }
        ],
        losading: false
      },
      body: {
        data: [],
        actions: [
          {
            title: 'asignar role',
            icon: 'mdi-border-color',
            color: 'lime lighten-1',
            action: 'toUpdatePassword'
          },
          {
            title: 'asignaciones',
            icon: 'mdi-border-color',
            color: 'lime lighten-1',
            action: 'toMunicipiosAssign'
          },
          {
            title: 'Cambio de Contraseña',
            icon: 'mdi-account-key',
            color: 'lime lighten-1',
            action: 'toUpdatePassword'
          }
        ]
      },
      footer: {
        paging: true
      }
    }
  }),
  components: {
    DataTableMain,
    EmployeeDialog
  },
  mounted () {
    this.getEmployees()
  },
  methods: {
    ...mapActions(['getEmployees']),

    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      this.table.header.loading = true
      this.getEmployees()
    },
    newData (item) {
      this.SHOW_DIALOG_MAIN({ type: 'create' })
    },
    tableAction (item) {
      this[item.action](item)
    },
    ...mapMutations(['SHOW_DIALOG_MAIN'])
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_employees'])
  },
  watch: {
    get_employees (vals) {
      if (vals) {
        this.table.header.loading = false
        this.table.body.data = vals
      }
    }
  }
}
</script>

<style></style>
